import { format, parseISO } from 'date-fns'

/**
 * Composable for date formatting
 * Replaces vue-moment filters with date-fns
 */
export function useDateFormat () {
  /**
   * Format a date using date-fns format strings
   * @param {Date|string|number} date - Date to format
   * @param {string} formatStr - Format string (default: 'yyyy-MM-dd HH:mm')
   * @returns {string} Formatted date string
   */
  const formatDate = (date, formatStr = 'yyyy-MM-dd HH:mm') => {
    if (!date) return ''

    try {
      // Handle different input types
      let dateObj = date

      if (typeof date === 'string') {
        // Try to parse ISO string
        dateObj = parseISO(date)
      } else if (typeof date === 'number') {
        // Unix timestamp
        dateObj = new Date(date)
      } else if (!(date instanceof Date)) {
        return ''
      }

      // Check if date is valid
      if (isNaN(dateObj.getTime())) {
        return ''
      }

      return format(dateObj, formatStr)
    } catch (error) {
      console.error('Date formatting error:', error)
      return ''
    }
  }

  /**
   * Format date with common presets
   */
  const formatDateTime = (date) => formatDate(date, 'yyyy-MM-dd HH:mm')
  const formatDateOnly = (date) => formatDate(date, 'yyyy-MM-dd')
  const formatTimeOnly = (date) => formatDate(date, 'HH:mm')
  const formatLongDate = (date) => formatDate(date, 'MMMM d, yyyy')
  const formatShortDate = (date) => formatDate(date, 'MM/dd/yyyy')
  const formatISODate = (date) => formatDate(date, "yyyy-MM-dd'T'HH:mm:ss")

  return {
    formatDate,
    formatDateTime,
    formatDateOnly,
    formatTimeOnly,
    formatLongDate,
    formatShortDate,
    formatISODate
  }
}
